export default __webpack_public_path__ + "static/media/fuddle2.b47fa7f3.png";